export default __webpack_public_path__ + "static/media/mileageimportsample.070679a6.xlsx";